import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

const ProtectedRoute = ({
  component: Component,
  render,
  isLoggedIn,
  ...rest
}: any) => {
  return (
    <Route
      {...rest}
      render={props => {
        if (!isLoggedIn)
          return (
            <Redirect
              to={{ pathname: '/signin', state: { from: props.location } }}
            />
          );
        return <Component {...props} />;
      }}
    />
  );
};

export default connect((state: any) => ({ isLoggedIn: state.user.isLoggedIn }))(
  ProtectedRoute,
);
